import { render, staticRenderFns } from "./associatedClinics.vue?vue&type=template&id=328523e0&"
import script from "./associatedClinics.vue?vue&type=script&lang=js&"
export * from "./associatedClinics.vue?vue&type=script&lang=js&"
import style0 from "./associatedClinics.vue?vue&type=style&index=0&id=328523e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports